"use strict";

module.exports = [{
  label: 'g/mL',
  value: 'g/mL'
}, {
  label: 'g/cm3',
  value: 'g/cm3'
}];